import * as React from "react";

type Props = {
    children: React.ReactNode;
};

type State = {
    displayed: boolean;
};

export default class HoverError extends React.Component<Props, State> {
    private _timer?: ReturnType<typeof setTimeout>;

    public state = {
        displayed: true,
    };

    public resetTimer = (): void => {
        if(this._timer) {
            clearTimeout(this._timer);
        }

        this._timer = setTimeout(() => {
            this.setState({
                displayed: false,
            });
        }, 5000);
    };

    public componentDidMount = (): void => {
        this.resetTimer();
    };

    public componentWillUnmount = (): void => {
        if(this._timer) {
            clearTimeout(this._timer);
        }
    };

    public componentDidUpdate = (prevProps: Readonly<Props>): void => {
        if(prevProps.children !== this.props.children) {
            this.resetTimer();
            this.setState({
                displayed: true,
            });
        }
    };

    public render(): React.ReactNode {
        const classes = [ "hover-error" ];

        if(this.state.displayed) {
            classes.push("displayed");
        }

        return (
            <div className={classes.join(" ")}>
                {this.props.children}
            </div>
        );
    }
}
